import createAxiosInstance from './createAxiosInstance';
import login from './login';

/**
 * @typedef ForgeRockAxiosInstanceCreatorParams
 * @type {import('./createAxiosInstance').ForgeRockAxiosInstanceCreatorParams}
 */

/**
 * @param {ForgeRockAxiosInstanceCreatorParams} axiosInstanceParams
 */
export default function createService(axiosInstanceParams) {
  const forgeRockAxiosInstance = createAxiosInstance(axiosInstanceParams);

  return {
    login: login(forgeRockAxiosInstance),
  };
}
